/**
 * Utility module for logging and error handling.
 * Provides styled logging, error logging, and user notifications.
 */
const utils = {

  /**
   * Logs a message to the console with custom styling.
   *
   * @param {string} name - A label or context for the log message.
   * @param {...any} args - Additional data to log to the console.
   */
  log(name, ...args) {
    const logTagStyle = 'color:#0073c1;'
    const logNameStyle = 'color:#67dffb;'

    console.log('%c[ NucleusXP ] %c' + name, logTagStyle, logNameStyle, ...args);
  },

  /**
   * Logs an error to the console with the [ NucleusXP ] tag.
   *
   * @param {...any} args - The error details to log to the console.
   */
  logError(...args) {
    console.error('[ NucleusXP ]', ...args);
  },

  /**
   * Displays an alert dialog with an error message.
   *
   * @param {string|Error} error - The error message or Error object to display.
   */
  errorMessage(error) {
    alert(error);
  }

};

export default utils;